import { BaseTransformationVisitor } from './baseTransformation.visitor';
import { SurrogateKeyPlainObject } from '../plainObjects/surrogateKey.plainObject';
import { SchemaUtil } from '../utils/schema.util';

export class SurrogateKeyVisitor extends BaseTransformationVisitor {
    private get _surrogateKeyTransformation(): SurrogateKeyPlainObject {
        return this.transformation as SurrogateKeyPlainObject;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public visitOutputDefinition(outputDefinitionContext: any): void {
        const schema = SchemaUtil.getSchemaFromInputOutputDefinition(outputDefinitionContext);
        this._surrogateKeyTransformation.keyColumn = schema[0];
    }
}
